import { render, staticRenderFns } from "./MobileSignUp.vue?vue&type=template&id=256fcb9a&scoped=true&"
import script from "./MobileSignUp.vue?vue&type=script&lang=js&"
export * from "./MobileSignUp.vue?vue&type=script&lang=js&"
import style0 from "./MobileSignUp.vue?vue&type=style&index=0&id=256fcb9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256fcb9a",
  null
  
)

export default component.exports